export enum CLOUDINARY {
  BASE_PATH = 'https://cldnr.kijk.nl/talpa-network/image/'
}
